import { render, staticRenderFns } from "./shopBasicInfo.vue?vue&type=template&id=71247fa8&"
import script from "./shopBasicInfo.vue?vue&type=script&lang=js&"
export * from "./shopBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports